export default {
  point: "Punkt:",
  point_other: "Punkte:",
};
